import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, CanActivateChild, Router, RouterStateSnapshot } from '@angular/router';
import { RoutesUtil } from '@shared-features/utils/routes.util';
import { UserApi } from '@shared-features/services/user-api.service';
import { UserRoleService } from '@shared/services';

@Injectable({
  providedIn: 'root',
})
export class AuthGuard implements CanActivate, CanActivateChild {
  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkAccessGrant(childRoute, state);
  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    return this.checkAccessGrant(route, state);
  }

  private checkAccessGrant(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    // Not signed in? Remember where they wanted to go, then send them to login.
    if (!this.userApi.isLoggedIn()) {
      this.userApi.redirectionURL = state.url;
      this.router.navigate([RoutesUtil.AuthLogin.url()]);
      return false;
    }

    const dashboardPrefix = '/' + RoutesUtil.Dashboards.path;

    // "landing" = this role's home page: will be dashboard page if the role can see it, otherwise the shipment list.
    const landing = this.userRoleService.landingRoute();

    // Redirect only when BOTH are true:
    //   - they're opening the dashboard (state.url starts with /dashboards)
    //   - the dashboard is NOT their home (their role can't see it)
    // -> send them to their own home instead of the "access denied" page.
    // Users who CAN see the dashboard skip this (their home IS the dashboard),
    // which avoids redirecting them onto the dashboard over and over (a loop).
    if (state.url.startsWith(dashboardPrefix) && !landing.startsWith(dashboardPrefix)) {
      this.router.navigateByUrl(landing);
      return false;
    }

    // Otherwise let the navigation continue as normal.
    return true;
  }

  constructor(private userApi: UserApi, private router: Router, private userRoleService: UserRoleService) {}
}
